import { useState } from 'react';
import useAiContentData from '../../helpers/useAiContentData';
import ChatBot from './ChatBot';

const ChatBotToggle = ({ isOpen: externalIsOpen, setIsOpen: externalSetIsOpen }) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = externalIsOpen !== undefined && externalSetIsOpen !== undefined;
  const isOpen = isControlled ? externalIsOpen : internalOpen;
  const setIsOpen = isControlled ? externalSetIsOpen : setInternalOpen;

  const { data, error: dataError, handleChange, createContent } = useAiContentData();

  if (!data) return null;

  return (
    <>
      {isOpen && (
        <ChatBot
          data={data}
          dataError={dataError}
          handleChange={handleChange}
          createContent={createContent}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};

export default ChatBotToggle;
